import { render } from "./Npm.vue?vue&type=template&id=1752f8d4&scoped=true"
import script from "./Npm.vue?vue&type=script&lang=js"
export * from "./Npm.vue?vue&type=script&lang=js"

import "./Npm.vue?vue&type=style&index=0&id=1752f8d4&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1752f8d4"]])

export default __exports__